import { Amount } from '@akropolis-web/primitives';
import React from 'react';

import { MaybeEither, toEither, left } from 'utils/either';
import { colors, styled } from 'core/styles';

import { FormattedAmount } from '../FormattedAmount';
import { FormattedAmountProps } from '../FormattedAmount/types';

type GrowthAmountProps = {
  growth: MaybeEither<MaybeEither<Amount | null>>;
  formattedAmountProps: Omit<FormattedAmountProps<Amount>, 'sum'>;
};

export function GrowthAmount({ growth, formattedAmountProps }: GrowthAmountProps) {
  return toEither(growth).fold(
    value =>
      toEither(value).fold(
        amount => {
          if (!amount || amount.eqValues(0)) {
            return <GrowthContainer variant="regular">–</GrowthContainer>;
          }

          return (
            <GrowthContainer variant={amount.gte(0) ? 'increase' : 'decrease'}>
              {amount.gte(0) && '+'}
              <FormattedAmount sum={amount} {...formattedAmountProps} />
            </GrowthContainer>
          );
        },
        error => <FormattedAmount sum={left(error)} />,
      ),
    error => <FormattedAmount sum={left(error)} />,
  );
}

const GrowthContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'variant',
})<{
  variant: 'increase' | 'decrease' | 'regular';
}>(({ variant }) => ({
  fontSize: 12,
  color: {
    increase: colors.greenShamrock,
    decrease: colors.scarlet[100],
    regular: '#fff',
  }[variant],
}));
